"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery/useMediaQuery"));
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _breakpoints = _interopRequireDefault(require("../config/breakpoints"));
var _helpers = require("./utils/helpers");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var Coffee = (0, _helpers.getImageByAgent)('coffee.svg');
var THANKYOU_MESSAGE_TIME_SEC = 5;
var useContactUsStyle = (0, _core.makeStyles)({
  dialog: {
    '& .MuiDialog-paper': {
      background: 'white linear-gradient(180deg, #F2FCFF 0, #FBFEFF 105px, #FFFFFF52 176px) 0% 0% no-repeat padding-box',
      borderRadius: 0
    }
  },
  root: {
    '&.mobile': {
      background: 'unset',
      border: 'none',
      borderRadius: 0,
      flexDirection: 'column',
      justifyContent: 'flex-start',
      padding: 0,
      top: 0
    },
    alignItems: 'center',
    background: '#fff',
    display: 'flex',
    height: 'calc(100% - 50px)',
    justifyContent: 'center',
    left: 20,
    overflow: 'visible',
    padding: '15px 25px 15px 15px',
    position: 'absolute',
    top: 38,
    width: 'calc(100% - 40px)',
    zIndex: 1
  },
  thankYou: {
    '& .title': {
      '& span': {
        display: 'block'
      },
      '@media screen and (max-width: 420px)': {
        fontSize: 20
      },
      color: _helpers.agentDeveloperUtils.getSecondaryColor(300),
      fontSize: 24,
      fontWeight: 700,
      marginTop: 20,
      textAlign: 'center'
    },
    '& img': {
      width: 104
    },
    '&.desktop': {
      '& .title': {
        '& span': {
          display: 'inline-block',
          maxWidth: 325,
          minWidth: 160
        },
        '& span:first-child': {
          marginRight: 12
        },
        flex: '0 1 325px',
        lineHeight: 1,
        marginLeft: 12,
        marginTop: 0,
        minHeight: 60,
        textAlign: 'left'
      },
      '& img': {
        width: 80
      },
      '&:before': {
        bottom: 'unset',
        top: -30
      },
      '&:before, &:after': {
        bottom: -30,
        color: _helpers.agentDeveloperUtils.getSecondaryColor(100),
        content: "\"".concat('•'.repeat(200), "\""),
        display: 'block',
        fontSize: 12,
        height: 10,
        letterSpacing: 2,
        lineHeight: 1,
        overflow: 'hidden',
        position: 'absolute',
        width: '100%'
      },
      alignItems: 'flex-end',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      marginBottom: 0,
      padding: 0,
      position: 'relative'
    },
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginBottom: 30,
    padding: '57px 0 50px 0',
    position: 'relative'
  }
});
var OfferIntegratedContactUs = function OfferIntegratedContactUs(_ref) {
  var showContactUs = _ref.showContactUs,
    closeContactUsHandler = _ref.closeContactUsHandler;
  var classes = useContactUsStyle();
  var isMobile = (0, _useMediaQuery.default)("(max-width:".concat(_breakpoints.default.mobile, "px)"));
  (0, _react.useEffect)(function () {
    if (showContactUs) {
      setTimeout(function () {
        closeContactUsHandler();
      }, THANKYOU_MESSAGE_TIME_SEC * 1000);
    }
  }, [showContactUs]);
  var Transition = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
    return /*#__PURE__*/_react.default.createElement(_core.Slide, _extends({
      direction: "up",
      ref: ref
    }, props));
  });
  var Content = /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(classes.root, " ").concat(isMobile ? 'mobile' : '')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(classes.thankYou, " ").concat(isMobile ? 'mobile' : 'desktop')
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: Coffee,
    alt: "coffee"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "title"
  }, /*#__PURE__*/_react.default.createElement("span", null, "\u05E4\u05E0\u05D9\u05D9\u05EA\u05DA \u05D4\u05EA\u05E7\u05D1\u05DC\u05D4 \u05D1\u05D4\u05E6\u05DC\u05D7\u05D4!"), /*#__PURE__*/_react.default.createElement("span", null, "\u05D4\u05D4\u05E6\u05E2\u05D4 \u05D4\u05D8\u05D5\u05D1\u05D4 \u05D1\u05D9\u05D5\u05EA\u05E8 \u05D1\u05D3\u05E8\u05DA \u05D0\u05DC\u05D9\u05DA..."))));
  if (showContactUs) {
    return isMobile ? /*#__PURE__*/_react.default.createElement(_core.Dialog, {
      fullScreen: true,
      open: showContactUs,
      TransitionComponent: Transition,
      className: classes.dialog
    }, Content) : /*#__PURE__*/_react.default.createElement(_core.Grow, {
      in: showContactUs
    }, Content);
  }
  return false;
};
var _default = exports.default = OfferIntegratedContactUs;